<script setup>
import IsolationTable from '@/views/quality/infection-control/isolation/IsolationTable.vue'

definePage({
  meta: {
    subject: 'quality.infection_control.menu',
    action: 'isolation',
  },
})
</script>

<template>
  <section>
    <IsolationTable />
  </section>
</template>
